import { Clickable } from '@carvana/merch-components';
import cx from 'classnames';
import { useContext } from 'react';
import type React from 'react';
import GeolocationIcon from '@/srp/GeolocationButton/GeolocationIcon';
import ModalContext from '~/context/srp/ModalContext';
import { useUserLocation } from '~/context/srp/UserContext';
import { IconWithTextWrapper } from './SearchHeader.styles';

export default function GeoLocationButton() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { city, state } = useUserLocation();
  const hasLocation = Boolean(city && state);

  const promptGeoModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setGeolocationModalOpen(true);
  };

  return (
    <Clickable
      className="w-fit"
      data-analytics-id="Geo Location"
      onClick={promptGeoModal}
    >
      <IconWithTextWrapper className="tl-body-s m:tl-body-m">
        <GeolocationIcon />
        <span className={cx('m-0 truncate', { 'text-grey-3': !hasLocation })}>
          {hasLocation ? `${city}, ${state}` : 'Current location...'}
        </span>
      </IconWithTextWrapper>
    </Clickable>
  );
}
